// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileContainer_container__BFrf2","header":"MobileContainer_header__1oKAn","placeholder":"MobileContainer_placeholder__BRjoa"};